import api from './api';

export enum UserRole {
  CLIENT = 'CLIENT',
  ANALYST = 'ANALYST',
  ADMINISTRATOR = 'ADMINISTRATOR',
}

export interface User {
  id: number;
  username: string;
  email: string;
  full_name: string;
  is_active: boolean;
  is_superuser: boolean;
  company_id: number;
  role: UserRole;
  created_at: string;
}

export interface UserCreate {
  username: string;
  email: string;
  full_name: string;
  password: string;
  is_active: boolean;
  company_id: number;
  role: UserRole;
}

export interface UserUpdate {
  username?: string;
  email?: string;
  full_name?: string;
  password?: string;
  is_active?: boolean;
  company_id?: number;
  role?: UserRole;
}

export const usersService = {
  // Get all users
  getAll: async (): Promise<User[]> => {
    const response = await api.get('/api/v2/users/');
    return response.data;
  },

  // Get analysts only
  getAnalysts: async (): Promise<User[]> => {
    const response = await api.get('/api/v2/users/', { params: { role: UserRole.ANALYST } });
    return response.data;
  },

  // Get user by ID
  getById: async (id: number): Promise<User> => {
    const response = await api.get(`/api/v2/users/${id}`);
    return response.data;
  },

  // Create new user
  create: async (userData: UserCreate): Promise<User> => {
    console.log('Creating user with data:', userData);
    console.log('UserCreate data type check:', {
      username: typeof userData.username,
      email: typeof userData.email,
      full_name: typeof userData.full_name,
      password: typeof userData.password,
      is_active: typeof userData.is_active,
      company_id: typeof userData.company_id,
      role: typeof userData.role,
    });

    try {
      const response = await api.post('/api/v2/users/', userData);
      console.log('User creation successful:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('User creation failed:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      throw error;
    }
  },

  // Update user
  update: async (id: number, userData: UserUpdate): Promise<User> => {
    const response = await api.put(`/api/v2/users/${id}`, userData);
    return response.data;
  },

  // Delete user
  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/v2/users/${id}`);
  },
};
